// Must come first: configures libraries before any imported module uses them.
import 'app/bootstrap.js';
import { createRoot } from 'react-dom/client';
import { Route, Router } from 'react-router-dom';
import { CompatRouter } from 'react-router-dom-v5-compat';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { store } from 'app/store/initializer';
import { history } from 'app/history';
import { ErrorBoundary } from 'app/components/plumbing/ErrorBoundary';
import { reportReactError } from 'app/lib/error';
import { guardTranslatedDom } from 'app/lib/dom';
import { Auth } from 'app/components/features/Auth';
import { initI18next, i18next } from 'app/i18next.js';
import * as styles from './main.css';

initI18next();

function preventDefaultDropAction() {
    window.addEventListener('dragover', (e) => e.preventDefault(), false);
    window.addEventListener('drop', (e) => e.preventDefault(), false);
}

function determineScrollbarThickness() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    const scrollbarThickness = outer.offsetWidth - inner.offsetWidth;

    document.body.removeChild(outer);

    window.SCROLLBAR_THICKNESS = scrollbarThickness;
}

function returnToHome() {
    window.location.href = '/';
}

export function mount() {
    guardTranslatedDom();

    const element = document.getElementById('app-container');
    const root = createRoot(element, { onCaughtError: reportReactError });

    element.className = styles.base;

    preventDefaultDropAction();
    determineScrollbarThickness();

    root.render(
        <ErrorBoundary onClose={returnToHome}>
            <I18nextProvider i18n={i18next}>
                <Provider store={store}>
                    <Router history={history}>
                        <CompatRouter>
                            <Route component={Auth} />
                        </CompatRouter>
                    </Router>
                </Provider>
            </I18nextProvider>
        </ErrorBoundary>
    );
}
